import { of } from 'rxjs';
import { tap, ignoreElements } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { getCompletedAsyncWrapperObj } from '@ane/core/lib/models';
import { produceLoadLoadingLoadedEpic } from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import NavigationService from '@ane/core/lib/services/NavigationService';
import { creatingCompute, createComputeActionTypes, createdCompute, updateComputeActionTypes, updatedCompute, updatingCompute, } from './ComputeCreateContainer.ducks';
import ComputeResource from '../../../../Compute.resource';
import { convertToComputePostParams } from '../CreateWizard/ComputeCreateFormSettings';
import { ComputeRouteUtils } from '@ane/exp-data/lib/routes/ComputeRoute.utils';
export const createComputeEpic = produceLoadLoadingLoadedEpic({
    filterOnType: createComputeActionTypes.LOAD,
    loadResource: (payload) => {
        let computePost = convertToComputePostParams(payload);
        return ComputeResource.postCompute(computePost);
    },
    loadingAction: (payload) => creatingCompute(),
    loadedAction: (successData, payload, error) => {
        return of(createdCompute(getCompletedAsyncWrapperObj(successData, error)));
    },
});
export const afterCreateCompute = (action$) => {
    return action$.pipe(ofType(createComputeActionTypes.LOADED), tap((action) => {
        let postParams = action.payload.createCompute.data;
        if (!!postParams && !!postParams.name && postParams.workspaceId) {
            NavigationService.navigateTo(ComputeRouteUtils.routes.root.getURL());
        }
    }), ignoreElements());
};
export const updateComputeEpic = produceLoadLoadingLoadedEpic({
    filterOnType: updateComputeActionTypes.LOAD,
    loadResource: (payload) => {
        let computePost = convertToComputePostParams(payload);
        return ComputeResource.putCompute(computePost);
    },
    loadingAction: (payload) => updatingCompute(),
    loadedAction: (successData, payload, error) => {
        return of(updatedCompute(getCompletedAsyncWrapperObj(successData, error)));
    },
});
export default combineEpics(createComputeEpic, afterCreateCompute, updateComputeEpic);

//# sourceMappingURL=ComputeCreateContainer.epic.js.map
